import { useState } from "react";
import "./TxnLookup.css";
import DummyTable from "./DummyTable";
import { getTransactionByField } from "../../../config/LiveApi";
import IndividualStatus from "./IndividualStatus";
import ReactSelect from "react-select";
import BulkStatusFile from "./BulkStatusFile";
import Spinner from "../../Spin/Spinner";
import BulkPayinStatus from "./BulkPayinStatus";
import BulkPayoutStatus from "./BulkPayoutStatus";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

function LookupHeader({ setProgress, setShowProgress }) {
  const token = useSelector((store) => store.userReducer.token);
  const [inData, setInData] = useState([]);
  const [showTableData, setShowTableData] = useState(false);
  const [showBulkStatus, setShowBulkStatus] = useState(false);
  const [showBulkPayInStatus, setShowBulkPayinStatus] = useState(false);
  const [showBulkPayoutStatus, setShowBulkPayoutStatus] = useState(false);
  const [typeData, setTypeData] = useState("");
  const [transactionStatus, setTransactionStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [bulkData, setBulkData] = useState(null);
  // const [searchValue, setSearchValue] = useState("");
  const [showResponse, setShowResponse] = useState(false);
  const [searchType, setSearchType] = useState("requestOrderId");
  const [searchId, setSearchId] = useState("");

  const getTransactionDetails = async () => {
    setIsLoading(true);

    try {
      if (!searchId.trim()) {
        toast.error(
          `Please provide ${searchType === "requestOrderId" ? "Order Id" : searchType === "responseUTR" ? "UTR Id" : searchType}`,
          { autoClose: 1000 },
        );
        return;
      }
      const bulkIds = searchId.split(",");

      const allTransactionData = await Promise.all(
        bulkIds.map(async (id) => {
          const response = await getTransactionByField(token, searchType, id);

          return response || [];
        }),
      );

      setInData(allTransactionData.flat());
      // setSearchValue("");
      setSearchId("");
    } catch (error) {
      console.error("Error fetching transaction details:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="lookup-box">
        <div className="header-section">
          <ReactSelect
            options={[
              { value: "requestOrderId", label: "Order Id" },
              { value: "responseUTR", label: "UTR Id" },
              { value: "transactionId", label: "Transaction Id" },
              { value: "referenceId", label: "Reference Id" },
            ]}
            className="search-select"
            onChange={(selectedOption) => setSearchType(selectedOption.value)}
            defaultValue={{ value: "orderId", label: "Order Id" }}
          />

          <input
            type="text"
            className="order-input"
            value={searchId}
            placeholder={
              searchType === "orderId"
                ? "Search By Order Id"
                : searchType === "responseUTR"
                  ? "Search By UTR Id"
                  : searchType === "transactionId"
                    ? "Search By Transaction Id"
                    : "Search By Reference Id"
            }
            onChange={(e) => setSearchId(e.target.value)}
          />

          <button className="search-btn" onClick={getTransactionDetails}>
            Search
          </button>

          <p>OR</p>
          <button
            className={showBulkStatus ? "disabled-button" : "search-btn"}
            onClick={() => setShowBulkStatus(!showBulkStatus)}
          >
            Bulk Status
          </button>
        </div>
        {showBulkStatus && (
          <div className="bulk-div">
            <BulkStatusFile
              setTypeData={setTypeData}
              typeData={typeData}
              setTransactionStatus={setTransactionStatus}
              transactionStatus={transactionStatus}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              startDate={startDate}
              endDate={endDate}
              setBulkData={setBulkData}
              setShowBulkPayinStatus={setShowBulkPayinStatus}
              setIsLoading={setIsLoading}
              setShowBulkPayoutStatus={setShowBulkPayoutStatus}
            />
          </div>
        )}

        <div className="dummyTable">
          {isLoading ? (
            <Spinner />
          ) : showBulkPayInStatus ? (
            bulkData &&
            bulkData.length > 0 &&
            bulkData[0].type === "payin" && (
              <BulkPayinStatus
                bulkData={bulkData}
                setBulkData={setBulkData}
                setProgress={setProgress}
                setShowProgress={setShowProgress}
              />
            )
          ) : showBulkPayoutStatus ? (
            bulkData &&
            bulkData.length > 0 &&
            bulkData[0].type === "payout" && (
              <BulkPayoutStatus
                bulkData={bulkData}
                setBulkData={setBulkData}
                setProgress={setProgress}
                setShowProgress={setShowProgress}
              />
            )
          ) : inData && inData.length > 0 ? (
            <IndividualStatus
              inData={inData}
              setInData={setInData}
              showTableData={showTableData}
              setShowTableData={setShowTableData}
            />
          ) : (
            <DummyTable />
          )}
        </div>
      </div>

      {showResponse && (
        <div className="lookup-box">
          <h2>Response</h2>
        </div>
      )}
    </>
  );
}

export default LookupHeader;
